import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords do not match");
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <AuthShell title="Create a new password" subtitle="Choose a password with at least 6 characters.">
      {done ? (
        <div className="space-y-4" data-testid="reset-success">
          <p className="rounded-md bg-emerald-50 border border-emerald-200 p-3 text-sm text-emerald-800">Password updated. You can now log in.</p>
          <Button asChild className="w-full bg-[#3B185F]" data-testid="reset-return-login-btn"><Link to="/login">Return to login</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div className="space-y-2">
            <Label>New password</Label>
            <Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
          </div>
          <div className="space-y-2">
            <Label>Confirm password</Label>
            <Input type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
          <Button type="submit" className="w-full h-11 bg-[#3B185F] hover:bg-[#250E3F]" data-testid="reset-submit-btn">Save new password</Button>
          <Link to="/login" className="block text-sm font-semibold text-[#3B185F]">← Back to login</Link>
        </form>
      )}
    </AuthShell>
  );
}
